
export default {
  methods: {
    enter(element) {
      const height = element.scrollHeight + "px"
      element.style.height = 0

      // Force repaint to make sure animation is triggered
      getComputedStyle(element).height

      requestAnimationFrame(() => {
        element.style.height = height
      })
    },
    afterEnter(element) {
      element.style.height = "auto"
    },
    leave(element) {
      const height = element.scrollHeight + "px"
      element.style.height = height

      // Force repaint to make sure animation is triggered
      getComputedStyle(element).height

      requestAnimationFrame(() => {
        element.style.height = 0
      })
    }
  }
}
